import {createGlobalStyle} from "styled-components";
import Montserrat from "../assets/fonts/montserrat/Montserrat-Light.otf";
import MontserratLight from "../assets/fonts/montserrat/Montserrat-UltraLight.otf";
import MontserratHair from "../assets/fonts/montserrat/Montserrat-Hairline.otf";
import MontserratBold from "../assets/fonts/montserrat/Montserrat-Bold.otf";

const GlobalStyle = createGlobalStyle`
   @font-face {
      font-family: 'Montserrat';
      font-style: normal;
      font-weight: 300;
      src: url(${Montserrat});
   }
   @font-face {
      font-family: 'Montserrat';
      font-style: lighter;
      font-weight: 200;
      src: url(${MontserratLight});
   }
   @font-face {
      font-family: 'Montserrat';
      font-style: lighter;
      font-weight: 100;
      src: url(${MontserratHair});
   }
   @font-face {
      font-family: 'Montserrat';
      font-style: bold;
      font-weight: 500;
      src: url(${MontserratBold});
   }

   body {
      font-family: 'Montserrat', sans-serif;
      color: #898B8E;
      background: #FFFFFF;
      margin: 0px;
      padding: 0;

   }

   button {
      border: none;
      outline: none;
   }


   ::-webkit-scrollbar {
      -webkit-appearance: none;
   }
   
   ::-webkit-scrollbar:vertical {
         width:10px;
   }
   
   ::-webkit-scrollbar-button:increment,::-webkit-scrollbar-button {
         display: none;
   } 
   
   ::-webkit-scrollbar:horizontal {
         height: 10px;
   }
   
   ::-webkit-scrollbar-thumb {
         background-color: #797979;
         border-radius: 20px;
         border: 2px solid #f1f2f3;
   }
   
   ::-webkit-scrollbar-track {
         border-radius: 10px;  
   }
   

`;

export default GlobalStyle;
